import React from 'react'
import Modal from 'material-ui/Modal'
import Paper from 'material-ui/Paper'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'
import Typography from 'material-ui/Typography'
import Select from 'material-ui/Select'
import Input, { InputLabel } from 'material-ui/Input'
import { MenuItem } from 'material-ui/Menu'
import Checkbox from 'material-ui/Checkbox'
import TextField from 'material-ui/TextField'
import Tabs, { Tab } from 'material-ui/Tabs'
import Switch from 'material-ui/Switch'
import Grid from 'material-ui/Grid';
import Radio, { RadioGroup } from 'material-ui/Radio';
import List, { ListItem, ListItemText } from 'material-ui/List';

import {
  FormControl,
  FormHelperText,
  FormControlLabel,
  FormLabel
} from 'material-ui/Form'
import { withStyles } from 'material-ui/styles'
import styles from './styles'

import {
  ModalHeader,
  ModalContents,
  ModalFooter
} from '../../common/modal'

import {
  validateFormData
} from '../../../common/formtool'


class RecertTests extends React.Component {

  constructor(props) {
    super(props)
    const { job } = props
    this.state = {
      open: true,
      errors: {},
      test: {
        cablestandard: "",
        linkmodel: "",
        cabletype: "",
        jobid: job.id
      }
    }
  }

  onChange = (e) => {
    let test = { ...this.state.test }
    test[e.target.name] = e.target.value
    this.setState({ test })
  }

  handleClose = () => {
    this.setState({
      open: false
    })
    this.props.cancel()
  }
  validate = () => {
    const { test } = this.state
    const { translate } = this.props
    let errors = {}

    let validationData = {
      cablestandard: {
        required: translate("formfield_error_general_required")
      },
      linkmodel: {
        required: translate("formfield_error_general_required")
      },
      cabletype: {
        required: translate("formfield_error_general_required")
      }
    }

    errors = validateFormData(test, validationData)

    if (Object.keys(errors).length) {
      this.setState({ errors })
      return false
    } else {
      return true
    }
  }

  recertTests() {
    let { test } = this.state
    const { pager } = this.props

    if (!this.validate()) {
      return
    }
    this.props.saveRecertTest(test, pager)
  }

  render() {

    const {
      classes,
      translate,
      job,
      multiple,
      selectedTests
    } = this.props;

    let {
      standards,
      error
    } = this.props

    const {
      test,
      errors,
    } = this.state

    let isLantek = test.cablestandard ? false : true;

    let cablestandards, cablebrands, connectorbrands, linkmodels, cabletypes;

    if (standards) {
      cablestandards = standards.cablestandards;
      cablebrands = standards.cablebrands;
      connectorbrands = standards.connectorbrands;
      
      linkmodels = test.cablestandard && cablestandards.find(x => x.id === test.cablestandard) ? cablestandards.find(x => x.id === test.cablestandard).linkmodels : null
      cabletypes = test.linkmodel && linkmodels.find(x => x.id === test.linkmodel) ? linkmodels.find(x => x.id === test.linkmodel).cabletypes : null

      if (selectedTests && selectedTests.length > 0) {
        var currentCableStandard = cablestandards.find((c) => {
            return c.name === selectedTests[0].cablestandardname;
        }); 
        
        if (currentCableStandard) {
          cablestandards = currentCableStandard.coax
            ? cablestandards.filter(x => x.coax === true)
            : cablestandards.filter(x => x.coax === false);
        }
      }

    }

    return (
      <Modal
        open={this.state.open}
        onClose={this.handleClose}
      >
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography type="headline" color="inherit">
                {translate("test_recertify_title")}
              </Typography>
              <Button
                className={classes.close}
                onClick={this.handleClose}
              >
                <Icon>clear</Icon>
              </Button>
            </ModalHeader>
            <ModalContents>

              <form noValidate autoComplete="off" className={classes.form}>
                <FormControl
                  className={classes.textField}
                  margin="normal"
                  error={errors.cablestandard ? true : false}
                >

                  <InputLabel htmlFor="cablestandard">{translate("test_cable_standard")}</InputLabel>
                  <Select
                    value={test.cablestandard}
                    onChange={this.onChange}
                    input={<Input name="cablestandard" id="cablestandard" value={test.cablestandard} />}
                    fullWidth
                  >
                    {
                      (cablestandards) ? (
                        cablestandards.map((standard, index) => {
                          return (
                            <MenuItem
                              key={index}
                              value={standard.id}
                            >
                              {standard.name}
                            </MenuItem>
                          )
                        })

                      ) : (null)
                    }
                  </Select>
                  <FormHelperText>{errors.cablestandard ? errors.cablestandard : translate("test_cable_standard_help")}</FormHelperText>
                </FormControl>

                <FormControl
                  className={classes.textField}
                  margin="normal"
                  error={errors.linkmodel ? true : false}
                >

                  <InputLabel htmlFor="linkmodel">{translate("test_link_model")}</InputLabel>
                  <Select
                    value={test.linkmodel}
                    onChange={this.onChange}
                    input={<Input name="linkmodel" id="linkmodel" value={test.linkmodel} />}
                    fullWidth
                  >
                    {
                      (linkmodels) ? (
                        linkmodels.map((linkmodel, index) => {
                          return (
                            <MenuItem
                              key={index}
                              value={linkmodel.id}
                            >
                              {linkmodel.name}
                            </MenuItem>
                          )
                        })

                      ) : (null)
                    }
                  </Select>
                  <FormHelperText>{errors.linkmodel ? errors.linkmodel : translate("test_link_model_help")}</FormHelperText>
                </FormControl>

                <FormControl
                  className={classes.textField}
                  margin="normal"
                  error={errors.cabletype ? true : false}
                >

                  <InputLabel htmlFor="cabletype">{translate("test_cable_type")}</InputLabel>
                  <Select
                    value={test.cabletype}
                    onChange={this.onChange}
                    input={<Input name="cabletype" id="cabletype" value={test.cabletype} />}
                    fullWidth
                  >
                    {
                      (cabletypes) ? (
                        cabletypes.map((cabletype, index) => {
                          return (
                            <MenuItem
                              key={index}
                              value={cabletype.id}
                            >
                              {cabletype.name}
                            </MenuItem>
                          )
                        })

                      ) : (null)
                    }
                  </Select>
                  <FormHelperText>{errors.cabletype ? errors.cabletype : translate("test_cable_type_help")}</FormHelperText>
                </FormControl>
              </form>
            </ModalContents>

            <ModalFooter>

              <Button raised
                className={classes.submit}
                onClick={() => this.recertTests()}
              >
                {translate("test_recertify")}
              </Button>
            </ModalFooter>
          </Paper>
        </div>
      </Modal>
    )
  }
}

export default withStyles(styles)(RecertTests)



// WEBPACK FOOTER //
// ./src/components/job/recert/index.js